import { FC } from 'react';

import { Modal } from '@/components/Modal/Modal';
import { Button } from '@/components/ui/Button/Button';
import { Typography } from '@/components/ui/Typography/Typography.styles';

import * as S from './ConfirmModal.styles';
import { ConfirmModalProps } from './ConfirmModal.types';

export const ConfirmModal: FC<ConfirmModalProps> = ({
  title,
  subtitle,
  confirmDataCy,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  confirmButtonProps,
  cancelButtonProps
}) => {
  const confirmDataAttribute = `confirm-modal-${confirmDataCy}-button`;
  const cancelDataAttribute = `confirm-modal-${confirmDataCy}-cancel-button`;

  return (
    <Modal onClose={onCancel} dataCy="confirm-modal">
      <S.Wrapper>
        <S.ContentWrapper>
          <Typography variant="h4">{title}</Typography>
          <S.Subtitle>{subtitle}</S.Subtitle>
        </S.ContentWrapper>

        <S.ModalActions>
          <Button
            fullWidth
            size="s"
            variant="activate"
            onClick={onCancel}
            data-cy={cancelDataAttribute}
            data-testid={cancelDataAttribute}
            typography="title5"
            {...cancelButtonProps}
          >
            {cancelLabel}
          </Button>

          <Button
            fullWidth
            size="s"
            variant="deactivate"
            onClick={onConfirm}
            data-cy={confirmDataAttribute}
            data-testid={confirmDataAttribute}
            typography="title5"
            {...confirmButtonProps}
          >
            {confirmLabel}
          </Button>
        </S.ModalActions>
      </S.Wrapper>
    </Modal>
  );
};
